import React from 'react'

import styles from './style.module.css'

type Props = {
  onYesterday: () => void
  onToday: () => void
  onLastMonth: () => void
  onCurrentMonth: () => void
}

export const QuickPeriodSelectButtons: React.FC<Props> = ({
  onYesterday,
  onToday,
  onLastMonth,
  onCurrentMonth,
}) => (
  <div className={styles.quickButtons}>
    <button type="button" className={styles.quickButton} onClick={onYesterday}>
      昨日
    </button>
    <button type="button" className={styles.quickButton} onClick={onToday}>
      今日
    </button>
    <button type="button" className={styles.quickButton} onClick={onLastMonth}>
      先月
    </button>
    <button type="button" className={styles.quickButton} onClick={onCurrentMonth}>
      今月
    </button>
  </div>
)
